import React from "react";

import "./style.scss";
import { whatsappURL } from "@/lib/TelephoneFormatter";
import whatsappIcon from "../../../static/images/flotting-whatsapp.svg";

const FloatingWhatsappButton = ({ whatsapp, message }: { whatsapp: string, message?: string }) => (
  <a target="_blank" href={whatsappURL(whatsapp, message)} className="whatsapp-float">
    <img src={whatsappIcon} alt="whatsapp icon" />
  </a>
);

export default FloatingWhatsappButton;
